<div class="inner-wrapper">
  <div class="item-container">
    <div class="item-header">
      <h2>Offline</h2>
      <p>Sorry but the application is currently offline please try again later.</p>
    </div>
  </div>
</div>
